/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getListBlocks.defs'
export { main as default } from './getListBlocks.defs'
